module.exports = __webpack_public_path__ + "static/img/ibp.4861762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ibp.png
// module id = IYOK
// module chunks = 22